import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';
    const whoNeedsHelp = getValueOrDefault(formConfig, formValues, 'whoNeedsHelp');
    const reasonForReport = getValueOrDefault(formConfig, formValues, 'reasonForReport');

    const getNextCustomerInfoPage = (currentPageId: string) => {
        switch (currentPageId) {
            case 'hvem':
                if (whoNeedsHelp.some((household: any) => household.value === 'mySelf')) {
                    return 'oplysninger-om-personen-1';
                } else if (whoNeedsHelp.some((household: any) => household.value === 'partner')) {
                    return 'oplysninger-om-personen-2';
                } else if (whoNeedsHelp.some((household: any) => household.value === 'child')) {
                    return 'oplysninger-om-personen-3';
                } else {
                    return 'dato';
                }

            case 'oplysninger-om-personen-1':
                if (whoNeedsHelp.some((household: any) => household.value === 'partner')) {
                    return 'oplysninger-om-personen-2';
                } else if (whoNeedsHelp.some((household: any) => household.value === 'child')) {
                    return 'oplysninger-om-personen-3';
                } else {
                    return 'dato';
                }

            case 'oplysninger-om-personen-2':
                if (whoNeedsHelp.some((household: any) => household.value === 'child')) {
                    return 'oplysninger-om-personen-3';
                } else {
                    return 'dato';
                }
        }
    };

    const getNextReportPage = (currentPageId: string) => {
        switch (currentPageId) {
            case 'aarsag':
                if (reasonForReport.some((reason: any) => ['psychologicalHelp', 'other'].includes(reason.value))) {
                    return 'beskriv-aarsag';
                } else if (reasonForReport.some((reason: any) => reason.value === 'hospitalization')) {
                    return 'beskriv-aarsag-indlaeggelse';
                } else if (reasonForReport.some((reason: any) => reason.value === 'preeclampsiaHospitalization')) {
                    return 'dato-for-indlaeggelse';
                } else if (reasonForReport.some((reason: any) => reason.value === 'criticalIllnessOrDisorder')) {
                    return 'vaelg-sygdom';
                } else if (
                    reasonForReport.some((reason: any) => reason.value === 'personalInjuryToChildAfterAccident')
                ) {
                    return 'beskriv-haendelse';
                } else {
                    return 'dokumentation';
                }

            case 'beskriv-aarsag':
                if (reasonForReport.some((reason: any) => reason.value === 'hospitalization')) {
                    return 'beskriv-aarsag-indlaeggelse';
                } else if (reasonForReport.some((reason: any) => reason.value === 'preeclampsiaHospitalization')) {
                    return 'dato-for-indlaeggelse';
                } else if (reasonForReport.some((reason: any) => reason.value === 'criticalIllnessOrDisorder')) {
                    return 'vaelg-sygdom';
                } else if (
                    reasonForReport.some((reason: any) => reason.value === 'personalInjuryToChildAfterAccident')
                ) {
                    return 'beskriv-haendelse';
                } else {
                    return 'dokumentation';
                }

            case 'dato-for-indlaeggelse':
                if (reasonForReport.some((reason: any) => reason.value === 'criticalIllnessOrDisorder')) {
                    return 'vaelg-sygdom';
                } else if (
                    reasonForReport.some((reason: any) => reason.value === 'personalInjuryToChildAfterAccident')
                ) {
                    return 'beskriv-haendelse';
                } else {
                    return 'dokumentation';
                }

            case 'vaelg-sygdom':
                if (reasonForReport.some((reason: any) => reason.value === 'personalInjuryToChildAfterAccident')) {
                    return 'beskriv-haendelse';
                } else {
                    return 'dokumentation';
                }
        }
    };

    switch (curPageId) {
        case 'godt-at-vide':
            return 'hvem';

        case 'hvem':
            nextPage = getNextCustomerInfoPage(curPageId);
            break;

        case 'oplysninger-om-personen-1':
            nextPage = getNextCustomerInfoPage(curPageId);
            break;

        case 'oplysninger-om-personen-2':
            nextPage = getNextCustomerInfoPage(curPageId);
            break;

        case 'oplysninger-om-personen-3':
            return 'dato';

        case 'dato':
            return 'foedselsdato';

        case 'foedselsdato':
            return 'aarsag';

        case 'aarsag':
            nextPage = getNextReportPage(curPageId);
            break;

        case 'beskriv-aarsag':
            nextPage = getNextReportPage(curPageId);
            break;

        case 'beskriv-aarsag-indlaeggelse':
            return 'dato-for-indlaeggelse';

        case 'dato-for-indlaeggelse':
            nextPage = getNextReportPage(curPageId);
            break;

        case 'vaelg-sygdom':
            nextPage = getNextReportPage(curPageId);
            break;

        case 'beskriv-haendelse':
            return 'dokumentation';

        case 'dokumentation':
            return 'evt';

        case 'evt':
            return 'om-dig';

        case 'om-dig':
            return 'resume';

        // undefined means it is the last page
        case 'resume':
            return undefined;

        default:
            throw new Error('getPagePrev: Unknown page: ' + curPageId);
    }

    return nextPage;
};
